import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class ConformidadeRevisao extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/ConformidadeRiscoPontoControleRevisaoLookup" {...this.props} />;
  }
}

export default ConformidadeRevisao;
